import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Sunrise, Sun, Moon } from 'lucide-react';
export function MechanismSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-cream px-4" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-6" data-id="element-177">
            El Método de Microajustes por Franja Horaria
          </h2>
          <p className="text-lg text-warmBrown max-w-3xl mx-auto leading-relaxed" data-id="element-178">
            Aquí es donde nuestro enfoque es diferente. No se trata de un
            régimen extremo, ni de contar calorías. Se trata de microajustes por
            franja horaria: pequeños cambios en tu alimentación y tus hábitos,
            sincronizados con los ritmos hormonales de tu cuerpo.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-179">
          {/* Morning */}
          <motion.div variants={cardVariants} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-gold" data-id="element-180">
            <div className="w-16 h-16 bg-gold/10 rounded-full flex items-center justify-center mb-6 mx-auto text-gold" data-id="element-181">
              <Sunrise className="w-10 h-10" data-id="element-182" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-forest mb-4 text-center" data-id="element-183">
              Mañana
            </h3>
            <p className="text-warmBrown/80 text-center" data-id="element-184">
              Un desayuno que te da energía estable toda la mañana, sincronizado
              con tu pico de cortisol natural.
            </p>
          </motion.div>

          {/* Afternoon */}
          <motion.div variants={cardVariants} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-sage" data-id="element-185">
            <div className="w-16 h-16 bg-sage/10 rounded-full flex items-center justify-center mb-6 mx-auto text-sage" data-id="element-186">
              <Sun className="w-10 h-10" data-id="element-187" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-forest mb-4 text-center" data-id="element-188">
              Tarde
            </h3>
            <p className="text-warmBrown/80 text-center" data-id="element-189">
              Meriendas estratégicas que eliminan los antojos y previenen los
              bajones de energía de media tarde.
            </p>
          </motion.div>

          {/* Night */}
          <motion.div variants={cardVariants} className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-forest" data-id="element-190">
            <div className="w-16 h-16 bg-forest/10 rounded-full flex items-center justify-center mb-6 mx-auto text-forest" data-id="element-191">
              <Moon className="w-10 h-10" data-id="element-192" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-forest mb-4 text-center" data-id="element-193">
              Noche
            </h3>
            <p className="text-warmBrown/80 text-center" data-id="element-194">
              Cenas ligeras diseñadas para mejorar el sueño y reducir bochornos
              nocturnos.
            </p>
          </motion.div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-12 text-sm text-warmBrown/60 font-medium tracking-wide uppercase" data-id="element-195">
          Basado en principios de cronobiología y nutrición hormonal
        </motion.p>
      </div>
    </section>;
}